import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "./Components/layout/Layout";
import "react-toastify/dist/ReactToastify.css";

import SignIn from "./Components/authentication/SignIn";
import SignUp from "./Components/authentication/SignUp";
import OTPVerification from "./Components/authentication/OTPVerification";
import ForgetPassword from "./Components/authentication/ForgetPassword";
import ResetPassword from "./Components/authentication/ResetPassword";
import Profile from "./Components/Profile/Profile";
import Visual from "./Components/VisualPresentation/VisualPresentation";

import CompanyDetails from "./Components/CompanyDetails/CompanyDetails";

import Templates from "./Components/Templete/Templete";
import FolderTemplateFileShow from "./Components/Templete/FolderTemplateFileShow";

import Phase1 from "./Components/VisualPresentation/Phase1";
import Phase2 from "./Components/VisualPresentation/Phase2";
import Phase3 from "./Components/VisualPresentation/Phase3";
import Phase4 from "./Components/VisualPresentation/Phase4";
import Phase5 from "./Components/VisualPresentation/Phase5";
import Slider from "./Components/VisualPresentation/Slider";
import AdminTodolistview from "./Components/TodoList/AdminTodolistview";
import Download from "./Components/Document/Download";
import Uplode from "./Components/Document/Uplode";

import AddUser from "./Components/AddUser/AddUser";

import TodoList from "./Components/TodoList/TodoList";
import UserTodolistview from "./Components/TodoList/UserTodolistview";

// import TodoListUser from "./Components/TodoListUser/TodoListUser";

import Setting from "./Components/Settings/Setting";

import DocxConverter from "./Components/DocxConverter/DocxConverter";

import FileUpload from "./Components/DocxConverter/FileUpload";

import Sidebar from "./Components/Common/Sidebar";
import Notification from "./Components/Notification/Notification";
import Dashboard from "./Components/Document/Dashboard";
import UserFolderView from "./Components/AddUser/UserFolderView";
import UserFolderFileShow from "./Components/AddUser/UserFolderFileShow";
import Records from "./Components/Templete/Records";
import UserContextProvider from "./context/UserContextProvider";

function App() {
  const Token = localStorage.getItem("Token");

  return (
    <>
      {/* <SignIn /> */}
      {/* <SignUp/> */}
      {/* <OTPVerification/> */}
      {/* <ForgetPassword/> */}
      {/* <ResetPassword/> */}
      {/* <Profile /> */}
      {/* <Form /> */}
      {/* <Visual /> */}
      {/* <Phase1 /> */}
      {/* <Example /> */}
      {/* <Card /> */}
      {/* <AppCard /> */}
      <UserContextProvider>
        <Routes>
          {/* <Route
          path="/signup"
          element={
            Token === null || Token === undefined ? <SignUp /> : <Templates />
          }
        /> */}

          <Route
            path="/"
            element={
              Token === null || Token === undefined ? <SignIn /> : <Templates />
            }
          />

          <Route
            exact
            path="/foldertemplatefileshow/:id/:fileId"
            element={<FolderTemplateFileShow />}
          />
          <Route exact path="/records" element={<Records />} />
          <Route exact path="/signup" element={<SignUp />} />
          <Route exact path="/signin" element={<SignIn />} />
          <Route exact path="/otp" element={<OTPVerification />} />
          <Route exact path="/forget" element={<ForgetPassword />} />
          <Route exact path="/reset/:link" element={<ResetPassword />} />
          <Route exact path="/" element={<Templates />} />
          <Route exact path="/download" element={<Download />} />
          <Route exact path="/uplode" element={<Uplode />} />

          <Route
            exact
            path="/companydetails/:id"
            element={<CompanyDetails />}
          />

          <Route exact path="/phase1" element={<Phase1 />} />
          <Route exact path="/phase2" element={<Phase2 />} />
          <Route exact path="/phase3" element={<Phase3 />} />
          <Route exact path="/phase4" element={<Phase4 />} />
          <Route exact path="/phase5" element={<Phase5 />} />
          <Route exact path="/slider" element={<Slider />} />

          <Route exact path="/addUser" element={<AddUser />} />

          <Route
            exact
            path="/userfolderview/:id"
            element={<UserFolderView />}
          />

          <Route
            exact
            path="/userfolderfileshow/:id/:fileId"
            element={<UserFolderFileShow />}
          />

          <Route exact path="/todolist" element={<TodoList />} />
          <Route
            exact
            path="/usertodolistview/:id"
            element={<UserTodolistview />}
          />
          <Route
            exact
            path="/admintodolistview/:id"
            element={<AdminTodolistview />}
          />
          {/* <Route exact path="/todolistuser" element={<TodoListUser />} /> */}

          <Route exact path="/visual" element={<Visual />} />
          <Route exact path="/profile" element={<Profile />} />

          <Route exact path="/setting" element={<Setting />} />

          <Route exact path="/DocxConverter" element={<DocxConverter />} />
          <Route exact path="/FileUpload" element={<FileUpload />} />
          <Route exact path="/dashboard" element={<Dashboard />} />
          <Route
            exact
            path="/admintodolistview/:id"
            element={<AdminTodolistview />}
          />

          <Route exact path="/notification" element={<Notification />} />
        </Routes>
      </UserContextProvider>
    </>
  );
}

export default App;
